import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { ApiUtils, StatementsApi } from '@shared/api';

interface UseDownloadStatementStore {
  loading: boolean;
  data: Blob | null;
  error: string | null;
  downloadStatement: (request: { statementId: string; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementStore = create<UseDownloadStatementStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  downloadStatement: async (request, isPreview, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await StatementsApi.downloadStatement(request.statementId, signal);
      !isPreview && FileUtils.downloadFile(result, request.filename);
      set({ loading: false, data: isPreview ? result || null : null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
